import * as request from '../utils/request'

// let baseUrl = 'https://cewud-agrinet.qixiuu.com'
// let baseUrl = "http://192.168.0.100:8088"


// 登录
export const apiLogin = (params) => request.post(`/admin/API/login`, params)
// export const apiLogin = (params) => request.post(baseUrl + `/admin/login`, params)

// 获取项目信息
export const getProject = (params) => request.get(`/ApiController/device/project/projectList`, params)
// 获取天气情况
export const getWeather = (params) => request.get(`/prediction/now`, params)



// 气象土壤监测
// 获取温室选项
export const getWsList = (params) => request.get(`/ApiController/device/greenhouse/list`, params)
// 获取温室信息数据
export const getSoli_weather = (params) => request.get(`/ApiController/device/greenhouse/listModel`, params)



// 虫情监测
// 获取设备id
export const getCQ_equipment = (params) => request.get(`/ApiController/device/pestMonitor/cbdList`, params)

// 环境温湿度
export const getCQ_weather = (params) => request.get(`/api/v1/cbd/environment`, params)
// 虫情趋势
export const getCQ_trend = (params) => request.get(`/api/v1/cbd/pestTrendLineChart`, params)
// 虫情走势信息
export const getCQ_tendency = (params) => request.get(`/api/v1/cbd/pestTrend`, params)
// 害虫占比/排名
export const getCQ_ranking = (params) => request.get(`/api/v1/cbd/pestRank`, params)


// 水肥一体化
// 项目信息
export const getQX_projectInfo = (params) => request.get(`/api/v1/bigScreen/projectInfo`, params)
// 气象土壤气息
export const getQX_wfQxInfo = (params) => request.get(`/api/v1/bigScreen/wfQxInfo`, params)
// 温室气象信息
export const getQX_modelInfo = (params) => request.get(`/ApiController/device/greenhouse/modelInfo`, params)
// 不同时期生长作物数据
export const getQX_cropGrowth = (params) => request.get(`/api/v1/bigScreen/cropGrowth`, params)
// 气象/土壤数据趋势
export const getQX_weatherSoilTrend = (params) => request.get(`/api/v1/bigScreen/weatherSoilTrend`, params)
// 监控列表
export const getQX_listMonitoring = (params) => request.get(`/api/v1/bigScreen/listMonitoring`, params)
// 获取视屏监控token
export const getQX_urlToken = (params) => request.get(`/api/v1/monitoring/token`, params)

